// src/components/ProtectedRoute.jsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import OnboardingGuard from './OnboardingGuard';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><p>Loading session...</p></div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Users with role 'user' can ONLY access /welcome — block everything else.
  // This is a limited fallback role, not a founder mid-onboarding, so the
  // onboarding gate below does not apply to it.
  if (user.role === 'user') {
    return location.pathname === '/welcome'
      ? <Outlet />
      : <Navigate to="/welcome" replace />;
  }

  // Onboarding hard gate, applied ONCE here so it covers every protected route
  // (including any that forgot the per-route wrapper). OnboardingGuard fails
  // open — it only blocks on positive confirmation that onboarding is incomplete.
  return (
    <OnboardingGuard>
      <Outlet />
    </OnboardingGuard>
  );
};

export default ProtectedRoute;
